<template>
    <div>
        <el-card class="box-card">
          <!-- 查询 start -->
          <el-form :inline="true" ref="keywordsRef" label-width="70px">
            <el-form-item>
              <el-button type="info" @click="backSensorData">返回</el-button>
            </el-form-item>
          </el-form>
          <!-- 查询 end -->

          <!-- 列表 -->
          <el-table :data="dataList" border stripe>
              <el-table-column prop="Mac" label="MAC" width="150px"></el-table-column>
              <el-table-column prop="Dataproperty" label="操作反馈" width="80px"></el-table-column>
              <el-table-column prop="Dianji" label="电机" width="60px"></el-table-column>
              <el-table-column prop="Tof" label="TOF" width="60px"></el-table-column>
              <el-table-column prop="Accx" label="ACC_X" width="80px"></el-table-column>
              <el-table-column prop="Accy" label="ACC_Y" width="80px"></el-table-column>
              <el-table-column prop="Accz" label="ACC_Z" width="80px"></el-table-column>
              <el-table-column prop="Als" label="ALS" width="80px"></el-table-column>
              <el-table-column prop="Ps" label="PS" width="60px"></el-table-column>
              <el-table-column prop="Err" label="ERR_CODE" width="100px"></el-table-column>
              <el-table-column prop="Caiji" label="采集时间" width="160px"></el-table-column>
              <el-table-column prop="Createtime" label="入库时间" width="160px"></el-table-column>
              <el-table-column prop="Dataid" label="数据id" width="70px"></el-table-column>
              <el-table-column prop="Hexdata" label="原始数据"></el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentPageChange"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="dataListnum"
			  :current-page.sync="selectedPageNo">
            </el-pagination>
          </div>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      downlinkgData: [],
      keywords: [],
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetSensorDatanum()
      this.apigetSensorDatalist()
    },
    backSensorData () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetSensorDatalist()
    },
    apigetSensorDatalist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetSensorDatalist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetSensorDatanum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetSensorDatanum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
